<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

(function() {
    'use strict';

    // Check if Monster Cart is active
    function isMonsterCartActive() {
        return !!document.querySelector('script[src*="/cart_renderer"]');
    }

    // Refresh Monster Cart if active
    function refreshMonsterCart() {
        if (isMonsterCartActive() && typeof monster_refresh === 'function') {
            monster_refresh(false);
        }
    }

    // Wrap the original Shopify.addItem to call monster_refresh after success
    var originalAddItem = Shopify.addItem;
    Shopify.addItem = function(variant_id, quantity, $target, callback, input) {
        var wrappedCallback = function(line_item) {
            if (typeof callback === 'function') {
                callback(line_item);
            }
            // Refresh Monster Cart after successful add
            refreshMonsterCart();
        };
        originalAddItem.call(Shopify, variant_id, quantity, $target, wrappedCallback, input);
    };

    // Also intercept fetch-based cart/add.js calls for actionAddToCart2
    var originalFetch = window.fetch;
    window.fetch = function(url, options) {
        return originalFetch.apply(this, arguments).then(function(response) {
            // Check if this is a cart/add.js request
            if (url && typeof url === 'string' && url.includes('cart/add.js')) {
                // Clone the response so we can check it
                var clonedResponse = response.clone();
                clonedResponse.json().then(function(data) {
                    // If add was successful (no error in response), refresh Monster Cart
                    if (data && !data.status) {
                        refreshMonsterCart();
                    }
                }).catch(function() {
                    // JSON parsing failed, still try to refresh
                });
            }
            return response;
        });
    };
})();
